import { AuthContextProps } from 'react-oidc-context';
import LimeClaimTypes from '../../models/limeClaimTypes';
import { limeApiFetch } from '../../utils/api';
import { getClaimValue } from '../../utils/authUser';
import {
  mapPopulationPulseResponses,
  parseEnrolledMembersCount,
} from './mapResponses';
import { HttpResult, PopulationPulseDashboardResult } from './types';

export async function loadPopulationPulseDashboard(
  auth: AuthContextProps,
): Promise<PopulationPulseDashboardResult> {
  const orgUuid = getClaimValue(auth.user, LimeClaimTypes.OrganisationUuid);
  const [momentumResponse, forecastResponse, memberStatsResponse] = await Promise.all([
    limeApiFetch('population-pulse/momentum', 'GET', auth),
    limeApiFetch('population-pulse/forecast', 'GET', auth),
    orgUuid
      ? limeApiFetch(
          `organisations/${orgUuid}/dashboard/memberStats`,
          'GET',
          auth,
        )
      : Promise.resolve(null),
  ]);

  const mapped = mapPopulationPulseResponses(
    await toHttpResult(momentumResponse),
    await toHttpResult(forecastResponse),
  );
  const memberStatsJson = memberStatsResponse
    ? (await toHttpResult(memberStatsResponse)).json
    : null;

  return {
    ...mapped,
    enrolledMembersCount: parseEnrolledMembersCount(memberStatsJson),
  };
}

async function toHttpResult(response: Response): Promise<HttpResult> {
  const contentType = response.headers.get('content-type') ?? '';
  if (contentType.toLowerCase().includes('json')) {
    try {
      const json = await response.json();
      return {
        status: response.status,
        json,
        text: typeof json === 'string' ? json : undefined,
      };
    } catch {
      return { status: response.status };
    }
  }

  return { status: response.status, text: await response.text() };
}
